<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch01-5">
<p class="centerImage"><img alt="images" id="img15" src="images/img15.jpg" style="max-width:100%;"/></p>
<p class="caption"><em class="italic">Half-hanged Smith, cut down from the gallows 12 December 1705.</em><span class="fontS">Author’s collection </span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08a_Fouldeeds_ch015.vue?75635612